import { Directive, ElementRef, Output, EventEmitter, HostListener } from '@angular/core';

@Directive({
    selector: '[scClickOutsidePas]',
    standalone: false
})
export class ClickOutsideDirective {

  @Output() clickOutSide = new EventEmitter<MouseEvent>();

  constructor(private _elementRef: ElementRef) {
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    if (!event.target) {
      return;
    }

    const clickedInside = this._elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.clickOutSide.emit(event);
    }
  }
}
